import { t } from "i18next";

export const countriesList = [
  {
    name: "United States",
    alpha_2: "US",
  },
  {
    name: "Canada",
    alpha_2: "CA",
  },
  {
    name: "United Kingdom",
    alpha_2: "GB",
  },
  {
    name: "Australia",
    alpha_2: "AU",
  },
];

export const countiesProvinceList = [
  {
    code: "US-WA",
    name: "Washington",
    type: "",
    parent_code: "US",
  },
  {
    code: "US-OR",
    name: "Oregon",
    type: "",
    parent_code: "US",
  },
  {
    code: "US-CA",
    name: "California",
    type: "",
    parent_code: "US",
  },
  {
    code: "GB-ENG",
    name: "England",
    type: "",
    parent_code: "GB",
  },
  {
    code: "GB-WLS",
    name: "Wales",
    type: "",
    parent_code: "GB",
  },
  {
    code: "GB-SCT",
    name: "Scotland",
    type: "",
    parent_code: "GB",
  },
  {
    code: "CA-BC",
    name: "British Columbia",
    type: "",
    parent_code: "CA",
  },
  {
    code: "CA-ON",
    name: "Ontario",
    type: "",
    parent_code: "CA",
  },
  {
    code: "CA-AB",
    name: "Alberta",
    type: "",
    parent_code: "CA",
  },
  {
    code: "AU-NSW",
    name: "New South Wales",
    type: "",
    parent_code: "AU",
  },
  {
    code: "AU-VIC",
    name: "Victoria",
    type: "",
    parent_code: "AU",
  },
  {
    code: "AU-QLD",
    name: "Queensland",
    type: "",
    parent_code: "AU",
  },
];

interface LabelDefinition {
  province_state: string;
  county: string;
  postal_code: string;
  unit: string;
  city: string;
}

export const customFieldLabels: Record<string, LabelDefinition> = {
  CA: {
    province_state: t("Province or territory"),
    county: t("County"),
    postal_code: t("Postal code"),
    unit: t("Apartment or unit number"),
    city: t("City or town"),
  },
  GB: {
    province_state: t("Nation"),
    county: t("County"),
    postal_code: t("Postcode"),
    unit: t("Address line 2"),
    city: t("City or town"),
  },
  AU: {
    province_state: t("State or territory"),
    county: t("County"),
    postal_code: t("Postcode"),
    unit: t("Apartment or unit number"),
    city: t("City or municipality"),
  },
  US: {
    province_state: t("State"),
    county: t("County"),
    postal_code: t("Zipcode"),
    unit: t("Apartment or unit number"),
    city: t("City or town"),
  },
};
